import { CommentDialog } from "@platform/btx-plan-designer";
import { useDialogs } from "@platform/hooks";

import type {
  CommentDialogData,
  DialogName,
} from "@platform/btx-plan-designer";

/**
 * Renders the Needs Review comment dialog driven by DialogProvider state.
 * Must live inside DialogProvider so useDialogs can read its context. Shared
 * by every tab that wires up CellReviewProvider (Comps, Quotes, Responses).
 */
export const CellReviewCommentDialogRenderer = (): React.JSX.Element | null => {
  const { getDialog, closeDialog } = useDialogs<DialogName>();
  const commentDialog = getDialog<CommentDialogData>("comment");
  if (!commentDialog?.isOpen || !commentDialog.data) return null;

  return (
    <CommentDialog
      open
      title={commentDialog.data.title ?? "Needs Review"}
      currentComment={commentDialog.data.currentComment}
      createdAt={commentDialog.data.createdAt}
      updatedAt={commentDialog.data.updatedAt}
      onSubmit={(comment) => {
        commentDialog.data?.onSubmit(comment);
        closeDialog("comment");
      }}
      onCancel={() => closeDialog("comment")}
    />
  );
};
